/** @jsx jsx */
import { useTranslate } from '@chordcommerce/gatsby-theme-autonomy'
import { Flex, jsx, Text } from 'theme-ui'

const CheckoutButtonAgeVerification = ({ parentForm }) => {
  const translate = useTranslate()
  const { register } = parentForm

  return (
    <Flex>
      <input
        type="checkbox"
        defaultChecked={true}
        name="ageVerification"
        id="ageVerification"
        ref={register()}
      />
      <Text
        as="label"
        variant="body3"
        aria-label={`${translate(
          'checkout.age_verification'
        )} Must be checked to continue.`}
        htmlFor="ageVerification"
        ml={1}
        mt="-2px"
      >
        {translate('checkout.age_verification')}
      </Text>
    </Flex>
  )
}

export default CheckoutButtonAgeVerification
